export default __webpack_public_path__ + "static/media/533.0bafead6.png";